import {
  GET_ALLOCATORS_DETAIL_INIT,
  GET_ALLOCATORS_DETAIL_SUCCESS,
  GET_ALLOCATORS_DETAIL_FAILED,
  FOLLOW_ALLOCATOR_INIT,
  FOLLOW_ALLOCATOR_SUCCESS,
  FOLLOW_ALLOCATOR_FAILED,
  CREATE_HEDGEFUND_AUDITLOGS_INIT,
  CREATE_HEDGEFUND_AUDITLOGS_SUCCESS,
  CREATE_HEDGEFUND_AUDITLOGS_FAILED,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED,
  GET_HEDGEFUND_USERS_INIT,
  GET_HEDGEFUND_USERS_SUCCESS,
  GET_HEDGEFUND_USERS_FAILED,
  GET_ALL_ADMIN_LIST_INIT,
  GET_ALL_ADMIN_LIST_SUCCESS,
  GET_ALL_ADMIN_LIST_FAILED,
  CREATE_APPOINTMENT_REQUEST,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILED,
  HEDGEFUND_CONNECTION_INIT,
  HEDGEFUND_CONNECTION_SUCCESS,
  HEDGEFUND_CONNECTION_FAILED,
  GET_ALLOCATOR_INFO_INIT,
  GET_ALLOCATOR_INFO_SUCCESS,
  GET_ALLOCATOR_INFO_FAILED,
  GET_ALLOCATOR_USER_LIST_INIT,
  GET_ALLOCATOR_USER_LIST_SUCCESS,
  GET_ALLOCATOR_USER_LIST_FAILED
} from "./constants";
const initialState = {
  allocatorDetail: {},
  allocatorUsers : [],
  allocatorUsersList : [],
  allocatorInfo : [],
  hedgefundUsers : [],
  adminUsers : [],
  loading : false,
  isSchedule : false,
};

export default function allocatorDetail(state = initialState, action) {
  switch (action.type) {
    case GET_ALLOCATORS_DETAIL_INIT:
      return { ...state, loading: true };
    case GET_ALLOCATORS_DETAIL_SUCCESS:
      return { ...state, loading: false, allocatorDetail: action.payload };
    case GET_ALLOCATORS_DETAIL_FAILED:
      return { ...state, loading: false };
    case FOLLOW_ALLOCATOR_INIT:
      return { ...state };
    case FOLLOW_ALLOCATOR_SUCCESS:
      // const newAllocator = state.funds.map((item) => {
      //   if (item.id === action.payload.allocatorId) {
      //     item.followed = action.payload.follow;
      //     return item;
      //   } else {
      //     return item;
      //   }
      // });
    
      // return { ...state, allocator: newAllocator };
      return { ...state };
    case FOLLOW_ALLOCATOR_FAILED:
      return { ...state }
    case CREATE_HEDGEFUND_AUDITLOGS_INIT:
      return { ...state };
    case CREATE_HEDGEFUND_AUDITLOGS_SUCCESS:
      return { ...state };
    case CREATE_HEDGEFUND_AUDITLOGS_FAILED:
      return { ...state };

    case GET_ALLOCATOR_USERS_INIT:
      return { ...state, allocatorUsers: [] };
    case GET_ALLOCATOR_USERS_SUCCESS:
      return {
        ...state,
        allocatorUsers: action.payload,
      };
    case GET_ALLOCATOR_USERS_FAILED:
      return { ...state};
    case GET_HEDGEFUND_USERS_INIT:
      return { ...state, allocatorUsers: [] };
    case GET_HEDGEFUND_USERS_SUCCESS:
      return {
        ...state,
        hedgefundUsers: action.payload,
      };
    case GET_HEDGEFUND_USERS_FAILED:
      return { ...state};

    case GET_ALL_ADMIN_LIST_INIT:
      return { ...state, allocatorUsers: [] };
    case GET_ALL_ADMIN_LIST_SUCCESS:
      return {
        ...state,
        adminUsers: action.payload,
      };
    case GET_ALL_ADMIN_LIST_FAILED:
      return { ...state};
    case CREATE_APPOINTMENT_REQUEST:
      return { ...state, loading: true };
    case CREATE_APPOINTMENT_SUCCESS:
      return { ...state, loading: false };
    case CREATE_APPOINTMENT_FAILED:
      return { ...state, loading: false };
    
    case HEDGEFUND_CONNECTION_INIT:
      return { ...state };
    case HEDGEFUND_CONNECTION_SUCCESS:
      return {
        ...state,
        isSchedule: action.payload,
      };
    case HEDGEFUND_CONNECTION_FAILED:
      return { ...state};
        
    case GET_ALLOCATOR_INFO_INIT:
      return { ...state };
    case GET_ALLOCATOR_INFO_SUCCESS:
      return {
        ...state,
        allocatorInfo: action.payload,
      };
    case GET_ALLOCATOR_INFO_FAILED:
      return { ...state};

    case GET_ALLOCATOR_USER_LIST_INIT:
      return { ...state };
    case GET_ALLOCATOR_USER_LIST_SUCCESS:
      return {
        ...state,
        allocatorUsersList: action.payload,
      };
    case GET_ALLOCATOR_USER_LIST_FAILED:
      return { ...state};
    default:
      return state;
  }
}
